// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import { SolyticsBox } from '../../package/components';

/**
 * srcDoc documents resolve "#section" links against the app URL, so in-page
 * links are handled here. Only the frame's window is scrolled (scrollIntoView
 * would also scroll the app), honouring the document's scroll-padding.
 */
const handleFrameLoad = (event) => {
  const frameDocument = event.currentTarget.contentDocument;
  const frameWindow = frameDocument?.defaultView;

  frameDocument?.addEventListener('click', (clickEvent) => {
    const anchor = clickEvent.target?.closest?.('a[href^="#"]');

    if (!anchor) {
      return;
    }

    clickEvent.preventDefault();

    let targetId = anchor.hash.slice(1);

    try {
      targetId = decodeURIComponent(targetId);
    } catch {
      // Fall back to the raw fragment when the report contains malformed escapes.
    }

    const target = frameDocument.getElementById(targetId);

    if (!target) {
      return;
    }

    const { scrollPaddingTop } = frameWindow.getComputedStyle(
      frameDocument.documentElement
    );
    frameWindow.scrollTo({
      top:
        target.getBoundingClientRect().top +
        frameWindow.scrollY -
        (parseFloat(scrollPaddingTop) || 0),
    });
  });
};

/**
 * Renders an HTML document in a sandboxed iframe. Scripts never run (no
 * allow-scripts); allow-same-origin only lets the app handle in-page links.
 */
const HtmlFrame = ({ html, title, sx }) => (
  <SolyticsBox
    component="iframe"
    title={title}
    srcDoc={html}
    sandbox="allow-same-origin"
    onLoad={handleFrameLoad}
    sx={{ width: '100%', display: 'block', border: 0, ...sx }}
  />
);

HtmlFrame.propTypes = {
  html: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  sx: PropTypes.shape({}),
};

export default HtmlFrame;
